function InitialiseSwipers()
{
    var swipers = document.querySelectorAll( ".swiper:not([data-pet-profile-swier])" );

    // console.log( swipers );
    swipers.forEach( function( swiperEl )
    {
        InitialiseSwiper( swiperEl )
    } );
}

function InitialiseSwiper( swiperEl )
{
    var swiperElID          = swiperEl.getAttribute( "data-swiper" );
    var swiperConfig        = {};
    var respectiveConfig    = document.querySelector( "[ data-swiper-target='" + swiperElID + "' ]" );

    if( respectiveConfig )
    {
        respectiveConfig = JSON.parse( respectiveConfig.innerHTML );
        swiperConfig = respectiveConfig;
    }

    var swiper = new Swiper( "." + swiperElID, swiperConfig )
}

function InitialiseFlickitySwipers()
{
    var swipers = document.querySelectorAll( "[data-flickity-target]" );

    swipers.forEach( function( swiper )
    {
        var swiperEl = document.querySelector( "." + swiper.dataset.flickityTarget );
        InitialiseFlickitySwiper( swiperEl, swiper )
    } );
}

function InitialiseFlickitySwiper( swiperEl, swiper )
{
    var swiperConfig = JSON.parse( swiper.textContent );

    if( swiperConfig )
    {
        swiperConfig.on = {};
        swiperConfig.on.ready = function() {
              swiperEl.classList.remove( "until-loaded" );
              swiperEl.style.height = "";
            };
        var swiper = new Flickity( swiperEl, swiperConfig );
    }
}

function HandleCartPopupCloseClick( e )
{
    var parent = SearchParentsFor( e.currentTarget, "cart-added-pop-up" );
    parent.setAttribute( "style", "display: none" );
}

function HandleCartPopupClose()
{
    var targets = document.querySelectorAll( ".cart-added-popup-close" );
    targets.forEach( function( target )
    {
        target.addEventListener( "click", HandleCartPopupCloseClick )
    } );
}

window.addEventListener( "load", function( e )
{
    InitialiseSwipers();
    InitialiseFlickitySwipers();
    HandleCartPopupClose();
} );